export const QUALITY_GRADES = ["A", "B", "C", "D", "F"] as const;

export const RATING_ACTIONS = ["buy", "sell", "hold", "delisted"] as const;

export const ITEMS_PER_PAGE_OPTIONS = [25, 50] as const;
export const DEFAULT_ITEMS_PER_PAGE = 25;


export const SUBSTACK_SUBSCRIBE_URL =
  import.meta.env.VITE_SUBSTACK_SUBSCRIBE_URL ||
  "https://dividendsroundtable.substack.com/subscribe";

export const APP_NAME = "Dividends Roundtable";
export const APP_DESCRIPTION = "Roger Conrad's Dividend Research Platform";
